@if (!edit){
<div class="d-flex w-100 profile-detail-row">
  <p>
    {{ title | translate }}
  </p>
  <span>{{ getString() }}</span>
</div>
}@else{
<div class="p-0 m-0 w-100">
  <p class="rightHeadings mt-3 mb-0">
    {{ title | translate }}
    @if(required){
    <span class="text-danger">*</span>
    }
  </p>
  <div data-multiselect class="d-flex flex-wrap">
    @for (option of combinedArray; track option.text) {
    <mat-checkbox
      matCheckbox
      class="button-like mt-2"
      type="checkbox"
      [checked]="isChecked(option.value)"
      (change)="onCheckboxChange($event, option.value)"
      class="button-like"
      value="{{ option.value }}">
      {{ option.text | translate }}
    </mat-checkbox>
    }
  </div>
</div>

}
